<template>
    <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
</template>

<script>
import ProcessosServicos from './ProcessosServicos'

export default {
    data() {
        return {
            comprometimento: {},
            erros: []
        }
    },

    methods: {
        obterComprometimentoResponsavel() {
            this.$store.dispatch('addRequest')
            let comprometimentoId = this.$route.query.c
            ProcessosServicos.obterComprometimentoResponsavel(
                comprometimentoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.comprometimento = response.data
                        this.confirmarFinalizarAvisosComprometimentoSemRegistroPagamento()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarFinalizarAvisosComprometimentoSemRegistroPagamento() {
            this.$swal({
                title: 'Avisos de Serviço Sem Registro de Pagamento',
                html: `Confirma a finalização dos avisos de "Sem Registro de Pagamento" do serviço <b>${this.comprometimento.idComprometimentoRequisicao}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.finalizarAvisosComprometimentoSemRegistroPagamento(
                        result.value
                    )
                } else {
                    this.$router.push('/')
                }
            })
        },

        finalizarAvisosComprometimentoSemRegistroPagamento() {
            this.$store.dispatch('addRequest')
            ProcessosServicos.finalizarAvisosComprometimentoSemRegistroPagamento(
                this.$route.query.c
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.finalizacaoRealizadaComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        finalizacaoRealizadaComSucesso() {
            this.$swal({
                title: 'Avisos de Serviço Sem Registro de Pagamento',
                html: `Finalizados com Sucesso`,
                icon: 'success'
            }).then(result => {
                if (result.value) {
                    this.$router.push('/')
                }
            })
        }
    },

    created() {
        this.obterComprometimentoResponsavel()
    }
}
</script>
